var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("reconciliation-step-template", {
    attrs: {
      nextStep: _vm.nextStep,
      previousStep: _vm.previousStep,
      loading: _vm.loading
    },
    on: {
      previous: function($event) {
        return _vm.$emit("previous")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h2", { staticClass: "mb-0" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Import de fichier CSV")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fs-3 gray-80 mt-2" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Importez régulièrement votre relevé bancaire afin de vous permettre de pointer vos différentes opérations bancaires avec vos documents SELLSY."
                    )
                  ) +
                  "\n        "
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ]
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "step1Form",
                    attrs: {
                      "label-position": "top",
                      model: _vm.formStep,
                      "inline-message": true,
                      "label-width": "120px"
                    }
                  },
                  [
                    _c("p", { staticClass: "fs-3 semibold mt-4" }, [
                      _vm._v(
                        "1 - " + _vm._s(_vm.$l10n.__("Votre compte bancaire"))
                      )
                    ]),
                    _vm._v(" "),
                    _vm.bankAccounts.length > 0
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "mb-2",
                            attrs: {
                              label: "",
                              prop: "bankAccount",
                              error: _vm.errors.get("bankAccount")
                            }
                          },
                          [
                            _c("select-input", {
                              attrs: {
                                mode: "edit",
                                options: _vm.bankAccounts,
                                idColumn: "id"
                              },
                              model: {
                                value: _vm.formStep.bankAccount,
                                callback: function($$v) {
                                  _vm.$set(_vm.formStep, "bankAccount", $$v)
                                },
                                expression: "formStep.bankAccount"
                              }
                            })
                          ],
                          1
                        )
                      : _c("p", { staticClass: "red" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Pas de compte bancaire")))
                        ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: {
                          href: "/?_f=bankAccountPreferences&action=bankInfo"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$l10n.__("Liste des comptes bancaires"))
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.displayAccountInputs
                      ? _c(
                          "div",
                          { staticClass: "my-2" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "mb-2",
                                attrs: {
                                  label: _vm.$t.__("common.labels.currency"),
                                  prop: "currencyId",
                                  error: _vm.errors.get("currencyId")
                                }
                              },
                              [
                                _c("select-input", {
                                  attrs: {
                                    mode: "edit",
                                    options: _vm.currencies,
                                    idColumn: "id",
                                    labelColumn: "name",
                                    filterable: true
                                  },
                                  model: {
                                    value: _vm.formStep.currencyId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formStep, "currencyId", $$v)
                                    },
                                    expression: "formStep.currencyId"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", { staticClass: "fs-3 semibold mt-4" }, [
                      _vm._v(
                        "\n                    2 - " +
                          _vm._s(
                            _vm.$l10n.__("Définissez le solde de votre compte")
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "",
                          prop: "balance",
                          error: _vm.errors.get("balance")
                        }
                      },
                      [
                        _c("amount-input", {
                          attrs: {
                            mode: "edit",
                            placeholder: _vm.$t.__(
                              "bankreconciliation.importsteps.ReconciliationStep1.exemple_placeholder"
                            ),
                            symbol: _vm.activeCurrency
                              ? _vm.activeCurrency.symbol
                              : ""
                          },
                          model: {
                            value: _vm.formStep.balance,
                            callback: function($$v) {
                              _vm.$set(_vm.formStep, "balance", $$v)
                            },
                            expression: "formStep.balance"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "fs-3 semibold mt-4 mb-0" }, [
                      _vm._v(
                        "\n                    3 - " +
                          _vm._s(
                            _vm.$l10n.__("Importez votre relevé bancaire")
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "fs-3 gray-80 mt-1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Le relevé bancaire doit être au format CSV."
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-container one-item prelative p-4"
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "mb-0 upload-item",
                            attrs: {
                              label: "",
                              prop: "file",
                              error: _vm.errors.get("file")
                            }
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "upload",
                                attrs: {
                                  action: "",
                                  limit: 1,
                                  "auto-upload": false,
                                  "on-change": _vm.updateFile
                                }
                              },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "bankreconciliation.importsteps.ReconciliationStep1.import_document"
                                    ),
                                    type: "primary"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.displayBankForm
                  ? _c("bank-form", {
                      attrs: { "default-bank-code": 1, "bank-codes": [] },
                      on: { close: _vm.toggleBankForm }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _vm.nextStep
              ? _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.continue"),
                    type: "primary",
                    disabled: _vm.bankAccounts.length == 0 || _vm.loading
                  },
                  on: { click: _vm.goToNextStep }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }